export const gamblingLogoURL =
  'https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/44662';
